import { useAuth } from '@/hooks';

export const useMailBox = () => {
  const { currUser } = useAuth();

  const connectedMailbox = currUser?.connected_mailbox || {};
  const connectedMailboxValue = Object?.keys(connectedMailbox).find(
    (key) => connectedMailbox?.[key] === true
  );
  const connectedCalendar = currUser?.connected_calendar || {};
  const canFetchMeetingRooms = currUser?.can_fetch_meeting_rooms;
  const connectedCalValue = Object?.keys(connectedCalendar).find(
    (key) => connectedCalendar?.[key] === true
  );

  return {
    isMailBoxConnected: connectedMailbox?.gmail || connectedMailbox?.outlook,
    isCalConnected: connectedCalendar?.gcal || connectedCalendar?.mscal,
    canFetchMeetingRooms: canFetchMeetingRooms,
    isOutlookEnabled: true,
    connectedMailboxValue: connectedMailboxValue,
    connectedCalValue,
  };
};
